export specialFields = {
  QUERY:        'QUERY'
  CREATE_FORM:  'CREATE_FORM'
  DATE_RANGE:   'DATE_RANGE'
  RADIO_OPTIONS: 'RADIO_OPTIONS'
  RELATION:     'RELATION'
  SWITCH_LABEL: 'SWITCH_LABEL'
  DATE_TIME:    'DATE_TIME'
}

export componentTypes = {
  id: {
    string: 'string'
  },
  default: {
    string: 'string'
    number: 'number'
    switch: 'switch'
    selectOrCreate: 'selectOrCreate'
    select: 'select'
    dateRange: 'dateRange'
    dateTime: 'dateTime'
    timePeriod: 'timePeriod'
    radio: 'radio'
  }
}

export orientation = {
  IN: 'IN'
  OUT: 'OUT'
}

export comparatorTypes = {
  EQUAL_TO: 'EQUAL_TO'
  NOT_EQUAL_TO: 'NOT_EQUAL_TO'
  GREATER_THAN: 'GREATER_THAN'
  LESS_THAN: 'LESS_THAN'
}